import request from '@/utils/request'

export function get(id){
  return request({
    url: '/inspectionPlanss/get?id='+id,
    method: 'get',
  })
}

export function StartInspection(id){
  return request({
    url: '/inspectionPlanss/StartInspection?id='+id,
    method: 'post',
  })
}

export function FinishInspection(id){
  return request({
    url: '/inspectionPlanss/FinishInspection?id='+id,
    method: 'post',
  })
}

export function GetInspectionDetail(id){
  return request({
    url: '/inspectionPlanss/GetInspectionDetail?code='+id,
    method: 'get',
  })
}

export function getList(params) {
  return request({
    url: '/inspectionPlanss/load',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/inspectionPlanss/add',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/inspectionPlanss/update',
    method: 'post',
    data
  })
}

export function del(data) {
  return request({
    url: '/inspectionPlanss/delete',
    method: 'post',
    data
  })
}

export function GetStoretions(){
  return request({
    url: '/inspectionPlanss/GetStoretions',
    method: 'get',
  })
}

export function GetDeptions(){
  return request({
    url: '/inspectionPlanss/GetDeptions',
    method: 'get',
  })
}

export function QueryInspectionDetail(previousStoreName, previousDepartment){
  return request({
    url: '/inspectionPlanss/QueryInspectionDetail?previousStoreName='+previousStoreName+'&previousDepartment='+previousDepartment,
    method: 'get',
  })
}

export function GetInspectionPerson(tenantCode){
  return request({
    url: '/inspectionPlanss/GetInspectionPerson?TenantCode='+tenantCode,
    method: 'get',
  })
}

export function GetResultDetails(inspectionCode){
  return request({
    url: '/inspectionPlanss/GetResultDetails?inspectionCode='+inspectionCode,
    method: 'get',
  })
}